var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 278,
    viewBox: "0 0 290 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 290,
    height: 277,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 40H106.276V46.0613H112.337V40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 40H118.175V46.0613H124.236V40Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 40H130.074V46.0613H136.135V40Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 40H136.134V46.0613H142.195V40Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 40H148.03V46.0613H154.091V40Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 40H159.929V46.0613H165.99V40Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 40H172.054V46.0613H178.115V40Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 40H189.787V46.0613H195.848V40Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 46.062H94.1552V52.1233H100.217V46.062Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 46.062H100.216V52.1233H106.277V46.062Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 46.062H106.276V52.1233H112.337V46.062Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 46.062H112.11V52.1233H118.172V46.062Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 46.062H118.175V52.1233H124.236V46.062Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 46.062H124.235V52.1233H130.296V46.062Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 46.062H141.969V52.1233H148.031V46.062Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 46.062H154.094V52.1233H160.155V46.062Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 46.062H172.054V52.1233H178.115V46.062Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 46.062H177.889V52.1233H183.95V46.062Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 46.062H189.787V52.1233H195.848V46.062Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 52.1222H94.1552V58.1835H100.217V52.1222Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 52.1222H124.235V58.1835H130.296V52.1222Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 52.1222H136.134V58.1835H142.195V52.1222Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 52.1222H141.969V58.1835H148.031V52.1222Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 52.1222H165.993V58.1835H172.054V52.1222Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 52.1222H172.054V58.1835H178.115V52.1222Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 52.1222H177.889V58.1835H183.95V52.1222Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 57.9596H94.1552V64.0209H100.217V57.9596Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 57.9596H106.276V64.0209H112.337V57.9596Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 57.9596H112.11V64.0209H118.172V57.9596Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 57.9596H118.175V64.0209H124.236V57.9596Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 57.9596H154.094V64.0209H160.155V57.9596Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 57.9596H159.929V64.0209H165.99V57.9596Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 57.9596H165.993V64.0209H172.054V57.9596Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 57.9596H177.889V64.0209H183.95V57.9596Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 64.0219H94.1552V70.0831H100.217V64.0219Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 64.0219H112.11V70.0831H118.172V64.0219Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 64.0219H118.175V70.0831H124.236V64.0219Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 64.0219H136.134V70.0831H142.195V64.0219Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 64.0219H148.03V70.0831H154.091V64.0219Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 64.0219H165.993V70.0831H172.054V64.0219Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 64.0219H172.054V70.0831H178.115V64.0219Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 64.0219H177.889V70.0831H183.95V64.0219Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 64.0219H183.949V70.0831H190.01V64.0219Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 70.082H94.1552V76.1433H100.217V70.082Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 70.082H100.216V76.1433H106.277V70.082Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 70.082H106.276V76.1433H112.337V70.082Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 70.082H130.074V76.1433H136.135V70.082Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 70.082H136.134V76.1433H142.195V70.082Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 70.082H148.03V76.1433H154.091V70.082Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 70.082H154.094V76.1433H160.155V70.082Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 70.082H177.889V76.1433H183.95V70.082Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 70.082H183.949V76.1433H190.01V70.082Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 75.9192H94.1552V81.9805H100.217V75.9192Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 75.9192H106.276V81.9805H112.337V75.9192Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 75.9192H118.175V81.9805H124.236V75.9192Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 75.9192H130.074V81.9805H136.135V75.9192Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 75.9192H141.969V81.9805H148.031V75.9192Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 75.9192H154.094V81.9805H160.155V75.9192Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 75.9192H165.993V81.9805H172.054V75.9192Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 75.9192H177.889V81.9805H183.95V75.9192Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 75.9192H189.787V81.9805H195.848V75.9192Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 81.9791H100.216V88.0404H106.277V81.9791Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 81.9791H106.276V88.0404H112.337V81.9791Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 81.9791H112.11V88.0404H118.172V81.9791Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 81.9791H118.175V88.0404H124.236V81.9791Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 81.9791H130.074V88.0404H136.135V81.9791Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 81.9791H136.134V88.0404H142.195V81.9791Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 81.9791H141.969V88.0404H148.031V81.9791Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 81.9791H148.03V88.0404H154.091V81.9791Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 81.9791H159.929V88.0404H165.99V81.9791Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 81.9791H183.949V88.0404H190.01V81.9791Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 81.9791H189.787V88.0404H195.848V81.9791Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 87.8162H58.461V93.8774H64.5223V87.8162Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 87.8162H76.4169V93.8774H82.4781V87.8162Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 87.8162H82.2558V93.8774H88.317V87.8162Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 87.8162H88.3163V93.8774H94.3776V87.8162Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 87.8162H94.1552V93.8774H100.217V87.8162Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 87.8162H100.216V93.8774H106.277V87.8162Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 87.8162H118.175V93.8774H124.236V87.8162Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 87.8162H124.235V93.8774H130.296V87.8162Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 87.8162H154.094V93.8774H160.155V87.8162Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 87.8162H159.929V93.8774H165.99V87.8162Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 87.8162H172.054V93.8774H178.115V87.8162Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 87.8162H177.889V93.8774H183.95V87.8162Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 87.8162H195.848V93.8774H201.91V87.8162Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 87.8162H207.747V93.8774H213.808V87.8162Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 87.8162H213.808V93.8774H219.869V87.8162Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 87.8162H219.868V93.8774H225.929V87.8162Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 87.8162H225.707V93.8774H231.768V87.8162Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 87.8162H231.767V93.8774H237.828V87.8162Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 93.8785H52.3975V99.9398H58.4588V93.8785Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 93.8785H58.461V99.9398H64.5223V93.8785Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 93.8785H64.2969V99.9398H70.3582V93.8785Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 93.8785H76.4169V99.9398H82.4781V93.8785Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 93.8785H100.216V99.9398H106.277V93.8785Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 93.8785H112.11V99.9398H118.172V93.8785Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 93.8785H118.175V99.9398H124.236V93.8785Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 93.8785H124.235V99.9398H130.296V93.8785Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 93.8785H130.074V99.9398H136.135V93.8785Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 93.8785H136.134V99.9398H142.195V93.8785Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 93.8785H148.03V99.9398H154.091V93.8785Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 93.8785H159.929V99.9398H165.99V93.8785Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 93.8785H165.993V99.9398H172.054V93.8785Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 93.8785H177.889V99.9398H183.95V93.8785Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 93.8785H183.949V99.9398H190.01V93.8785Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 93.8785H189.787V99.9398H195.848V93.8785Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 93.8785H207.747V99.9398H213.808V93.8785Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 93.8785H219.868V99.9398H225.929V93.8785Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 93.8785H231.767V99.9398H237.828V93.8785Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 93.8785H237.602V99.9398H243.663V93.8785Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 99.939H82.2558V106H88.317V99.939Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 99.939H100.216V106H106.277V99.939Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 99.939H201.909V106H207.97V99.939Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 99.939H219.868V106H225.929V99.939Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 99.939H225.707V106H231.768V99.939Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 105.776H46.3369V111.837H52.3982V105.776Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 105.776H52.3975V111.837H58.4588V105.776Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 105.776H58.461V111.837H64.5223V105.776Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 105.776H64.2969V111.837H70.3582V105.776Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 105.776H70.3569V111.837H76.4182V105.776Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 105.776H88.3163V111.837H94.3776V105.776Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 105.776H189.787V111.837H195.848V105.776Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 105.776H201.909V111.837H207.97V105.776Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 105.776H207.747V111.837H213.808V105.776Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 105.776H225.707V111.837H231.768V105.776Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 105.776H237.602V111.837H243.663V105.776Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 111.838H70.3569V117.899H76.4182V111.838Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 111.838H76.4169V117.899H82.4781V111.838Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 111.838H82.2558V117.899H88.317V111.838Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 111.838H88.3163V117.899H94.3776V111.838Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 111.838H183.949V117.899H190.01V111.838Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 111.838H189.787V117.899H195.848V111.838Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 111.838H195.848V117.899H201.91V111.838Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 111.838H201.909V117.899H207.97V111.838Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 111.838H213.808V117.899H219.869V111.838Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 111.838H219.868V117.899H225.929V111.838Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 111.838H225.707V117.899H231.768V111.838Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 111.838H231.767V117.899H237.828V111.838Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 111.838H237.602V117.899H243.663V111.838Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 117.898H46.3369V123.959H52.3982V117.898Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 117.898H52.3975V123.959H58.4588V117.898Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 117.898H64.2969V123.959H70.3582V117.898Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 117.898H70.3569V123.959H76.4182V117.898Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 117.898H88.3163V123.959H94.3776V117.898Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 117.898H183.949V123.959H190.01V117.898Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 117.898H189.787V123.959H195.848V117.898Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 117.898H195.848V123.959H201.91V117.898Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 117.898H201.909V123.959H207.97V117.898Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 123.736H46.3369V129.797H52.3982V123.736Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 123.736H58.461V129.797H64.5223V123.736Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 123.736H64.2969V129.797H70.3582V123.736Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 123.736H70.3569V129.797H76.4182V123.736Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 123.736H76.4169V129.797H82.4781V123.736Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 123.736H82.2558V129.797H88.317V123.736Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 123.736H88.3163V129.797H94.3776V123.736Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 123.736H189.787V129.797H195.848V123.736Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 123.736H201.909V129.797H207.97V123.736Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 123.736H213.808V129.797H219.869V123.736Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 123.736H219.868V129.797H225.929V123.736Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 123.736H225.707V129.797H231.768V123.736Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 123.736H237.602V129.797H243.663V123.736Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 129.796H46.3369V135.857H52.3982V129.796Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 129.796H64.2969V135.857H70.3582V129.796Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 129.796H183.949V135.857H190.01V129.796Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 129.796H201.909V135.857H207.97V129.796Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 129.796H237.602V135.857H243.663V129.796Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 135.632H64.2969V141.694H70.3582V135.632Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 135.632H82.2558V141.694H88.317V135.632Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 135.632H183.949V141.694H190.01V135.632Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 135.632H189.787V141.694H195.848V135.632Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 135.632H195.848V141.694H201.91V135.632Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 135.632H201.909V141.694H207.97V135.632Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 135.632H207.747V141.694H213.808V135.632Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 135.632H213.808V141.694H219.869V135.632Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 135.632H219.868V141.694H225.929V135.632Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 135.632H225.707V141.694H231.768V135.632Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 135.632H231.767V141.694H237.828V135.632Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 141.694H58.461V147.756H64.5223V141.694Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 141.694H64.2969V147.756H70.3582V141.694Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 141.694H76.4169V147.756H82.4781V141.694Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 141.694H88.3163V147.756H94.3776V141.694Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 141.694H94.1552V147.756H100.217V141.694Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 141.694H195.848V147.756H201.91V141.694Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 147.755H52.3975V153.816H58.4588V147.755Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 147.755H58.461V153.816H64.5223V147.755Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 147.755H82.2558V153.816H88.317V147.755Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 147.755H88.3163V153.816H94.3776V147.755Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 147.755H100.216V153.816H106.277V147.755Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 147.755H183.949V153.816H190.01V147.755Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 147.755H213.808V153.816H219.869V147.755Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 147.755H225.707V153.816H231.768V147.755Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 147.755H231.767V153.816H237.828V147.755Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 147.755H237.602V153.816H243.663V147.755Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 153.592H58.461V159.654H64.5223V153.592Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 153.592H64.2969V159.654H70.3582V153.592Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 153.592H76.4169V159.654H82.4781V153.592Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 153.592H94.1552V159.654H100.217V153.592Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 153.592H100.216V159.654H106.277V153.592Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 153.592H183.949V159.654H190.01V153.592Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 153.592H189.787V159.654H195.848V153.592Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 153.592H201.909V159.654H207.97V153.592Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 153.592H207.747V159.654H213.808V153.592Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 153.592H225.707V159.654H231.768V153.592Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 153.592H231.767V159.654H237.828V153.592Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 153.592H237.602V159.654H243.663V153.592Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 159.654H46.3369V165.716H52.3982V159.654Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 159.654H64.2969V165.716H70.3582V159.654Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 159.654H76.4169V165.716H82.4781V159.654Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 159.654H82.2558V165.716H88.317V159.654Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 159.654H88.3163V165.716H94.3776V159.654Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 159.654H94.1552V165.716H100.217V159.654Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 159.654H183.949V165.716H190.01V159.654Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 159.654H207.747V165.716H213.808V159.654Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 159.654H225.707V165.716H231.768V159.654Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 159.654H237.602V165.716H243.663V159.654Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 165.715H58.461V171.776H64.5223V165.715Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 165.715H64.2969V171.776H70.3582V165.715Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 165.715H76.4169V171.776H82.4781V165.715Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 165.715H88.3163V171.776H94.3776V165.715Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 165.715H94.1552V171.776H100.217V165.715Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 165.715H219.868V171.776H225.929V165.715Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 165.715H231.767V171.776H237.828V165.715Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 165.715H237.602V171.776H243.663V165.715Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 171.552H46.3369V177.613H52.3982V171.552Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 171.552H52.3975V177.613H58.4588V171.552Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 171.552H58.461V177.613H64.5223V171.552Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 171.552H64.2969V177.613H70.3582V171.552Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 171.552H82.2558V177.613H88.317V171.552Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 171.552H94.1552V177.613H100.217V171.552Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 171.552H100.216V177.613H106.277V171.552Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 171.552H183.949V177.613H190.01V171.552Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 171.552H201.909V177.613H207.97V171.552Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 177.612H58.461V183.673H64.5223V177.612Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 177.612H64.2969V183.673H70.3582V177.612Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 177.612H70.3569V183.673H76.4182V177.612Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 177.612H76.4169V183.673H82.4781V177.612Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 177.612H88.3163V183.673H94.3776V177.612Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 177.612H112.11V183.673H118.172V177.612Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 177.612H118.175V183.673H124.236V177.612Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 177.612H124.235V183.673H130.296V177.612Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 177.612H136.134V183.673H142.195V177.612Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 177.612H141.969V183.673H148.031V177.612Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 177.612H148.03V183.673H154.091V177.612Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 177.612H154.094V183.673H160.155V177.612Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 177.612H159.929V183.673H165.99V177.612Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 177.612H177.889V183.673H183.95V177.612Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 177.612H195.848V183.673H201.91V177.612Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 177.612H201.909V183.673H207.97V177.612Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 177.612H207.747V183.673H213.808V177.612Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 177.612H237.602V183.673H243.663V177.612Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3982 183.451H46.3369V189.512H52.3982V183.451Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4588 183.451H52.3975V189.512H58.4588V183.451Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5223 183.451H58.461V189.512H64.5223V183.451Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4182 183.451H70.3569V189.512H76.4182V183.451Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 183.451H82.2558V189.512H88.317V183.451Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3776 183.451H88.3163V189.512H94.3776V183.451Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 183.451H100.216V189.512H106.277V183.451Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 183.451H106.276V189.512H112.337V183.451Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 183.451H112.11V189.512H118.172V183.451Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 183.451H118.175V189.512H124.236V183.451Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 183.451H130.074V189.512H136.135V183.451Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 183.451H136.134V189.512H142.195V183.451Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 183.451H141.969V189.512H148.031V183.451Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 183.451H154.094V189.512H160.155V183.451Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 183.451H159.929V189.512H165.99V183.451Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 183.451H172.054V189.512H178.115V183.451Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 183.451H177.889V189.512H183.95V183.451Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 183.451H183.949V189.512H190.01V183.451Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 183.451H189.787V189.512H195.848V183.451Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 183.451H195.848V189.512H201.91V183.451Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 183.451H201.909V189.512H207.97V183.451Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 183.451H207.747V189.512H213.808V183.451Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 183.451H213.808V189.512H219.869V183.451Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 183.451H225.707V189.512H231.768V183.451Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 183.451H231.767V189.512H237.828V183.451Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 183.451H237.602V189.512H243.663V183.451Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 189.511H94.1552V195.572H100.217V189.511Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 189.511H118.175V195.572H124.236V189.511Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 189.511H124.235V195.572H130.296V189.511Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 189.511H141.969V195.572H148.031V189.511Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 189.511H172.054V195.572H178.115V189.511Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 189.511H183.949V195.572H190.01V189.511Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 189.511H189.787V195.572H195.848V189.511Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 189.511H213.808V195.572H219.869V189.511Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 189.511H219.868V195.572H225.929V189.511Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 189.511H231.767V195.572H237.828V189.511Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 189.511H237.602V195.572H243.663V189.511Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 195.571H94.1552V201.633H100.217V195.571Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 195.571H106.276V201.633H112.337V195.571Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 195.571H112.11V201.633H118.172V195.571Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 195.571H118.175V201.633H124.236V195.571Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 195.571H141.969V201.633H148.031V195.571Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 195.571H154.094V201.633H160.155V195.571Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 195.571H159.929V201.633H165.99V195.571Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 195.571H183.949V201.633H190.01V195.571Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 195.571H189.787V201.633H195.848V195.571Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 195.571H201.909V201.633H207.97V195.571Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 195.571H213.808V201.633H219.869V195.571Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 195.571H219.868V201.633H225.929V195.571Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 201.41H94.1552V207.471H100.217V201.41Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 201.41H100.216V207.471H106.277V201.41Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 201.41H106.276V207.471H112.337V201.41Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 201.41H118.175V207.471H124.236V201.41Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 201.41H124.235V207.471H130.296V201.41Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 201.41H130.074V207.471H136.135V201.41Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 201.41H141.969V207.471H148.031V201.41Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 201.41H148.03V207.471H154.091V201.41Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 201.41H165.993V207.471H172.054V201.41Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 201.41H172.054V207.471H178.115V201.41Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 201.41H189.787V207.471H195.848V201.41Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 201.41H213.808V207.471H219.869V201.41Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 201.41H225.707V207.471H231.768V201.41Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 201.41H237.602V207.471H243.663V201.41Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 207.47H106.276V213.532H112.337V207.47Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 207.47H112.11V213.532H118.172V207.47Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 207.47H124.235V213.532H130.296V207.47Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 207.47H136.134V213.532H142.195V207.47Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 207.47H141.969V213.532H148.031V207.47Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 207.47H154.094V213.532H160.155V207.47Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 207.47H172.054V213.532H178.115V207.47Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 207.47H189.787V213.532H195.848V207.47Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 207.47H195.848V213.532H201.91V207.47Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 207.47H201.909V213.532H207.97V207.47Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 207.47H207.747V213.532H213.808V207.47Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 207.47H213.808V213.532H219.869V207.47Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 207.47H225.707V213.532H231.768V207.47Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 207.47H231.767V213.532H237.828V207.47Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 207.47H237.602V213.532H243.663V207.47Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 213.531H100.216V219.592H106.277V213.531Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 213.531H118.175V219.592H124.236V213.531Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M136.135 213.531H130.074V219.592H136.135V213.531Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 213.531H136.134V219.592H142.195V213.531Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 213.531H165.993V219.592H172.054V213.531Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 213.531H183.949V219.592H190.01V213.531Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 213.531H189.787V219.592H195.848V213.531Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 213.531H195.848V219.592H201.91V213.531Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 213.531H219.868V219.592H225.929V213.531Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 213.531H225.707V219.592H231.768V213.531Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 213.531H231.767V219.592H237.828V213.531Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 219.369H94.1552V225.431H100.217V219.369Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 219.369H100.216V225.431H106.277V219.369Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 219.369H112.11V225.431H118.172V219.369Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 219.369H136.134V225.431H142.195V219.369Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M154.091 219.369H148.03V225.431H154.091V219.369Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 219.369H154.094V225.431H160.155V219.369Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 219.369H159.929V225.431H165.99V219.369Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M172.054 219.369H165.993V225.431H172.054V219.369Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 219.369H189.787V225.431H195.848V219.369Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 219.369H195.848V225.431H201.91V219.369Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M207.97 219.369H201.909V225.431H207.97V219.369Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M213.808 219.369H207.747V225.431H213.808V219.369Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 219.369H219.868V225.431H225.929V219.369Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 219.369H231.767V225.431H237.828V219.369Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 219.369H237.602V225.431H243.663V219.369Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M106.277 225.43H100.216V231.491H106.277V225.43Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 225.43H106.276V231.491H112.337V225.43Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 225.43H112.11V231.491H118.172V225.43Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 225.43H141.969V231.491H148.031V225.43Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 225.43H154.094V231.491H160.155V225.43Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M165.99 225.43H159.929V231.491H165.99V225.43Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M178.115 225.43H172.054V231.491H178.115V225.43Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 225.43H177.889V231.491H183.95V225.43Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 225.43H183.949V231.491H190.01V225.43Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M195.848 225.43H189.787V231.491H195.848V225.43Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 225.43H195.848V231.491H201.91V225.43Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 225.43H213.808V231.491H219.869V225.43Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 225.43H219.868V231.491H225.929V225.43Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 225.43H225.707V231.491H231.768V225.43Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 225.43H231.767V231.491H237.828V225.43Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 225.43H237.602V231.491H243.663V225.43Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M112.337 231.267H106.276V237.328H112.337V231.267Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M130.296 231.267H124.235V237.328H130.296V231.267Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 231.267H136.134V237.328H142.195V231.267Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M148.031 231.267H141.969V237.328H148.031V231.267Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 231.267H195.848V237.328H201.91V231.267Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M219.869 231.267H213.808V237.328H219.869V231.267Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 231.267H219.868V237.328H225.929V231.267Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M231.768 231.267H225.707V237.328H231.768V231.267Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M243.663 231.267H237.602V237.328H243.663V231.267Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6839 40C47.0104 40 46.3369 40.6735 46.3369 41.3469V46.0613V52.1225V57.9593V64.0206V70.0818V75.9186V80.6329C46.3369 81.3064 47.0104 81.9799 47.6839 81.9799H86.9698C87.6433 81.9799 88.3168 81.3064 88.3168 80.6329V75.9186V69.8573V63.7961V57.9593V51.898V46.0613V41.3469C88.3168 40.6735 87.6433 40 86.9698 40H47.6839ZM82.2555 52.1225V57.9593V64.0206V70.0818V75.2451C82.2555 75.6941 82.031 75.9186 81.582 75.9186H53.0716C52.6227 75.9186 52.3982 75.6941 52.3982 75.2451V70.0818V64.0206V57.9593V51.898V46.7347C52.3982 46.2858 52.6227 46.0613 53.0716 46.0613H81.582C82.031 46.0613 82.2555 46.2858 82.2555 46.7347V52.1225Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4196 64.0199V57.9586V53.2443C76.4196 52.5708 75.7461 51.8973 75.0726 51.8973H59.5827C58.9093 51.8973 58.2358 52.5708 58.2358 53.2443V57.9586V64.0199V68.7342C58.2358 69.4076 58.9093 70.0811 59.5827 70.0811H75.0726C75.7461 70.0811 76.4196 69.4076 76.4196 68.7342V64.0199Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M203.03 40C202.356 40 201.683 40.6735 201.683 41.3469V46.0613V52.1225V57.9593V64.0206V70.0818V75.9186V80.6329C201.683 81.3064 202.356 81.9799 203.03 81.9799H242.316C242.989 81.9799 243.663 81.3064 243.663 80.6329V75.9186V69.8573V63.7961V57.9593V51.898V46.0613V41.3469C243.663 40.6735 242.989 40 242.316 40H203.03ZM237.602 52.1225V57.9593V64.0206V70.0818V75.2451C237.602 75.6941 237.377 75.9186 236.928 75.9186H208.642C208.193 75.9186 207.969 75.6941 207.969 75.2451V70.0818V64.0206V57.9593V51.898V46.7347C207.969 46.2858 208.193 46.0613 208.642 46.0613H237.153C237.602 46.0613 237.826 46.2858 237.826 46.7347V52.1225H237.602Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M231.766 64.0199V57.9586V53.2443C231.766 52.5708 231.093 51.8973 230.419 51.8973H214.929C214.256 51.8973 213.582 52.5708 213.582 53.2443V57.9586V64.0199V68.7342C213.582 69.4076 214.256 70.0811 214.929 70.0811H230.419C231.093 70.0811 231.766 69.4076 231.766 68.7342V64.0199Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6839 195.571C47.0104 195.571 46.3369 196.245 46.3369 196.918V201.633V207.694V213.755V219.816V225.878V231.939V236.653C46.3369 237.327 47.0104 238 47.6839 238H86.9698C87.6433 238 88.3168 237.327 88.3168 236.653V231.939V225.878V219.816V213.755V207.694V201.633V196.918C88.3168 196.245 87.6433 195.571 86.9698 195.571H47.6839ZM82.2555 207.469V213.531V219.592V225.653V230.816C82.2555 231.265 82.031 231.49 81.582 231.49H53.0716C52.6227 231.49 52.3982 231.265 52.3982 230.816V225.653V219.592V213.531V207.469V202.306C52.3982 201.857 52.6227 201.633 53.0716 201.633H81.582C82.031 201.633 82.2555 201.857 82.2555 202.306V207.469Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4196 219.368V213.306V208.592C76.4196 207.919 75.7461 207.245 75.0726 207.245H59.5827C58.9093 207.245 58.2358 207.919 58.2358 208.592V213.306V219.368V224.082C58.2358 224.755 58.9093 225.429 59.5827 225.429H75.0726C75.7461 225.429 76.4196 224.755 76.4196 224.082V219.368Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M174.971 106.001H113.91V167.961H174.971V106.001Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.645 159.429C120.196 162.123 122.666 164.143 124.911 162.796L132.543 158.307C135.462 156.735 138.156 155.837 141.299 155.837H155.666C159.931 155.837 163.748 152.694 164.421 148.429L169.36 120.817C170.033 117.225 167.34 113.857 163.523 113.857C154.319 113.857 145.115 113.857 135.911 113.857C131.645 113.857 127.829 117 127.156 121.266C125.135 134.286 122.89 146.633 120.645 159.429ZM157.013 125.306L157.462 122.613C157.686 121.266 159.033 120.143 160.38 120.143H163.748L163.299 122.837C163.074 124.184 161.952 125.306 160.38 125.306H157.013ZM144.89 126.653C150.503 126.653 153.197 130.919 152.074 136.082L150.054 147.756C149.829 149.103 148.482 150.225 147.135 150.225H143.768L146.013 136.98C146.462 134.062 145.339 132.266 142.421 132.266C139.278 132.266 137.033 134.286 136.584 137.204L134.339 149.552C134.115 150.449 133.666 151.123 132.992 151.572L127.605 154.49L133.217 122.613C133.441 121.266 134.788 120.143 136.135 120.143H139.503L137.707 129.796C139.503 127.551 141.972 126.653 144.89 126.653ZM152.523 150L156.115 129.572C156.339 128.225 157.686 127.102 159.033 127.102H162.401L158.809 147.531C158.584 149.103 157.462 150 156.115 150H152.523Z",
    fill: "#ED325D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.b567537f545b1096345a862185d562e8.svg";
export { ForwardRef as ReactComponent };